import React from 'react';
import { TrendingUp } from 'lucide-react';
export function ProofSection() {
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-128">
      <div className="max-w-4xl mx-auto" data-id="element-129">
        <div className="bg-brand-navy text-white rounded-3xl p-8 md:p-16 text-center shadow-2xl relative overflow-hidden" data-id="element-130">
          <div className="absolute top-0 right-0 -mr-16 -mt-16 opacity-10" data-id="element-131">
            <TrendingUp className="w-64 h-64" data-id="element-132" />
          </div>

          <div className="relative z-10" data-id="element-133">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-brand-gold mb-8" data-id="element-134">
              Lo que cambia en tus primeros 30 días:
            </h2>

            <p className="font-body text-xl md:text-2xl leading-relaxed text-gray-200 mb-8" data-id="element-135">
              No te prometo el cielo, pero te prometo claridad. En tus primeros
              30 días, habrás forzado a los burós a investigar tus cuentas.
            </p>

            <div className="bg-white/10 p-6 md:p-8 rounded-2xl backdrop-blur-sm border border-white/20" data-id="element-136">
              <p className="font-body text-lg md:text-xl font-medium text-white" data-id="element-137">
                Muchas mujeres ven sus primeras eliminaciones de cuentas de
                colección en este primer periodo, lo que genera saltos de{' '}
                <span className="text-brand-gold font-bold text-2xl" data-id="element-138">
                  20 a 45 puntos
                </span>{' '}
                antes de lo que imaginaban.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}